<template>
  <div class="pb-8 md:pb-20">
    <h2 class="text-3xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6 overflow-auto underline font-bold">Subscription Options</h2>
    <h3 class="text-center max-w-[500px] mx-auto"> Subscribers gain unlimited access to NationalHorseman.com including our
      <nuxt-link class="cursor-pointer underline font-bold" to="/issue">online archive</nuxt-link>
      and <nuxt-link class="cursor-pointer underline font-bold" to="/horse-shows">show results</nuxt-link>
      database
    </h3>


    <div class="border border-black border-x-0 border-t-0">
      <button @click="currentTabComponent = Tab1"
              :class="[ currentTabComponent === Tab1 ? 'border-b-white border-black text-themeRed' : 'border-white border-b-black']"
              class="font-bold -mb-px py-2.5 px-5 border rounded-b-none focus:border-b-white focus:border-black rounded
              hover:bg-gray-100 hover:opacity-70 uppercase"
      >Print
      </button>
<!--      for gift subscription uncomment this-->
      <!--      <button @click="currentTabComponent = Tab2" :class="[ currentTabComponent === Tab2 ? 'border-b-white border-gray-300 text-themeRed' : 'border-white border-b-gray-300']" class="font-bold -mb-px py-2.5 px-3.5 border rounded-b-none focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70">Give a gift</button>-->
      <button @click="currentTabComponent = Tab3"
              :class="[ currentTabComponent === Tab3 ? 'border-b-white border-black text-themeRed' : 'border-white border-b-black']"
              class="font-bold -mb-px py-2.5 px-5 border rounded-b-none focus:border-b-white focus:border-black rounded hover:bg-gray-100
               hover:opacity-70 uppercase"
      >Digital
      </button>
    </div>
    <KeepAlive>
      <component :is="currentTabComponent"></component>
    </KeepAlive>
  </div>
</template>

<script setup>
  import Tab1 from "@/components/subscribe/Tab1.vue";
  // import Tab2 from "@/components/subscribe/Tab2.vue";
  import Tab3 from "@/components/subscribe/Tab3.vue";
  import {shallowRef} from "vue";

  let currentTabComponent = shallowRef(Tab1)
</script>
